import { ref, watch, computed } from "@vue/composition-api";
import axios from "@axios";
import { useToast } from "vue-toastification/composition";

export default function useList() {
  const tableColumns = [
    { key: "actions", sortable: false, label: "Acciones" },
    { key: "name", sortable: true, label: "Nombre" },
    { key: "tenant.name", sortable: true, label: "Tenant" },
  ];

  const perPage = ref(10);
  const currentPage = ref(1);
  const totalList = ref(0);
  const searchQuery = ref("");
  const sortBy = ref("name");
  const isSortDirDesc = ref(false);
  const perPageOptions = [10, 25, 50, 100];

  const refListTable = ref(null);
  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    };
  });

  const toast = useToast();
  const fetchList = (ctx, callback) => {
    axios
      .get("/v1/security_self_audit_templates", {
        params: {
          q: searchQuery.value,
          perPage: perPage.value,
          page: currentPage.value,
          sortBy: sortBy.value,
          sortDesc: isSortDirDesc.value,
        },
      })
      .then((response) => {
        const { data } = response.data;
        totalList.value = response.data.total;
        callback(data);
      })
      .catch(() => {
        toast.error("Error al obtener la lista de plantillas de Security Self Audit");
      });
  };

  watch([perPage, currentPage, searchQuery], () => {
    refetchData();
  });

  const refetchData = () => {
    if (refListTable.value) refListTable.value.refresh();
  };

  return {
    fetchList,
    tableColumns,
    perPage,
    currentPage,
    totalList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    refetchData,
  };
}
